import Axios from "../helpers/axios";

export const getVideoByVideoId = (video_id) => {
  return Axios.get(`/files/video/${video_id}`);
};
